import React from 'react';
import { pipe, } from 'ramda';
import { useLocation, } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import WithPaper from 'common/hocs/WithPaper';
import Button from 'common/components/Button';
import Icon from 'common/components/Icon';
import BoxComponentWrapper from 'common/components/BoxComponentWrapper';
import Divider from './components/Divider';
import { LOGIN_LINK, SIGNUP_LINK, RECOVERY_PASSWORD_LINK, } from 'common/constants';
import { pages, } from 'styles';

const Login = () => {
    const location = useLocation();
    const typographyWhenHasAccountIconClasses = pages.login.makeTypographyIconStyles({ hasAccount: true, });
    const typographyWhenHasntAccountIconClasses = pages.login.makeTypographyIconStyles({ hasAccount: false, });
    const referrer = location?.state?.referrer;

    const redirectionLink = referrer ? window.location.origin + referrer : window.location.origin + '/products';
    const redirect = encodeURIComponent(redirectionLink);

    return (
        <Box mx={{ lg: 30, }}>
            <Grid container>
                <Grid item
                      xs={12}>
                    <Box mb={{ xs: 2, sm: 5, }}
                         display="flex"
                         justifyContent="center">
                        <Box display="flex"
                             alignItems="center"
                             mr={2}>
                            <Icon.Info height={25} />
                        </Box>
                        <div>
                            Oferta dostępna wyłącznie dla szkół. Zamówienia mogą składać nauczyciele, dyrektorzy lub osoby upoważnione do składania zamówień w imieniu szkoły (pełnomocnik).
                        </div>
                    </Box>
                </Grid>
                <Box display={{ sm: 'flex', }}
                     alignItems={{ sm: 'flex-start', }}
                     component={BoxComponentWrapper(<Grid item
                                                          xs={12} />)}>
                    <Box my={3}
                         component={BoxComponentWrapper(<Grid container
                                                              justify="center"
                                                              alignItems="center" />)}>
                        <Box width={140}>
                            <Grid container
                                  direction="column">
                                <Typography classes={typographyWhenHasAccountIconClasses}>Mam konto...</Typography>
                                <Box my={2}
                                     width={120}>
                                    <Button href={`${LOGIN_LINK}?redirect=${redirect}`}>
                                        Zaloguj się
                                    </Button>
                                </Box>
                                <Link href={RECOVERY_PASSWORD_LINK}
                                      color="inherit">
                                    Nie pamiętasz hasła?
                                </Link>
                            </Grid>
                        </Box>
                    </Box>
                    <Divider />
                    <Box mt={3}
                        component={BoxComponentWrapper(<Grid container
                                                             justify="center"
                                                             alignItems="center" />)}>
                        <Box width={140}>
                            <Grid container
                                  direction="column">
                                <Typography classes={typographyWhenHasntAccountIconClasses}>Nie mam konta...</Typography>
                                <Box my={2}
                                     width={120}>
                                    <Button href={`${SIGNUP_LINK}?redirect=${redirect}`}>
                                        Załóż konto
                                    </Button>
                                </Box>
                            </Grid>
                        </Box>
                    </Box>
                </Box>
            </Grid>
        </Box>
    );
};

export default pipe<any, React.FC>(
    WithPaper(null),
)(Login);
